// If want to replace useContractAccess or other nested composable for customization, need remove relative import and setup auto-import
import useContractAccess from './access/useContractAccess'

export default () => {
    const accessMap = new Map()

    useContractAccess(accessMap)

    const hasAccess: HasAccessFunction = (accessRule, data?) => accessMap.get(accessRule)(data)
    return {hasAccess}
}
